/**
 * Mirrors the CSS variables in `styles/lean-in/_tokens.scss` so React
 * inline-style code and CSS-module code share one source of truth. Drift
 * between TS and SCSS will produce visibly inconsistent animation.
 */
export const MOTION = {
    duration: {
        fast: 120,
        base: 200,
        slow: 320,
    },
    easing: {
        standard: 'cubic-bezier(0.2, 0, 0, 1)',
        accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
        decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
    },
    /** Canonical hover/press/focus transition for every interactive surface. */
    transition: 'all 120ms cubic-bezier(0.2, 0, 0, 1)',
};
/**
 * Resolves to `--color-focus-ring` (navy on light surfaces) — see
 * `styles/lean-in/_colors.scss` for the WCAG-1.4.11 contrast rationale.
 * Pass `inset: true` for rows flush against a popover/modal edge so the
 * ring sits inside the row rather than spilling past it.
 */
export function focusRing(visible, { inset = false } = {}) {
    if (!visible)
        return { outline: 'none', outlineOffset: 0 };
    return {
        outline: '2px solid var(--color-focus-ring, var(--palette-navy))',
        outlineOffset: inset ? -2 : 2,
    };
}
//# sourceMappingURL=motion.js.map